module.exports = __webpack_public_path__ + "static/img/leftData.eb30716f.png";